import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import AppShell from "@/components/AppShell";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Home from "@/pages/Home";
import Save from "@/pages/Save";
import Vault from "@/pages/Vault";
import Market from "@/pages/Market";
import Circle from "@/pages/Circle";
import Redeem from "@/pages/Redeem";
import Notifications from "@/pages/Notifications";
import Profile from "@/pages/Profile";
import Landing from "@/pages/Landing";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-ivory">
        <div className="skeleton-gold h-3 w-40 rounded-full" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/home" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/home" element={<Home />} />
              <Route path="/save" element={<Save />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/market" element={<Market />} />
              <Route path="/circle" element={<Circle />} />
              <Route path="/redeem" element={<Redeem />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}
